export default __webpack_public_path__ + "static/media/AT_logo_3_blu.f4291a83.svg";